module.exports = {
	"title": "Home/Community Hazard Assessment Tool",
	"label": "",
	"description": [
		"With information gathered from the pre-visit and pre-travel assessments, a number of controls should already be in place. However, front-line staff must continue to assess risk as a regular part of their daily work routine. Observation and communication skills are very important when assessing and minimizing risk. Any findings that deviate from what has been deemed acceptable should be immediately reported by the worker, following the reporting procedures established at the organization."
	],
	"meta": {
		"noRiskInstructions": {
			"complete_vat": "Complete the Violence Assessment Tool (VAT) at the first point of contact",
			"continue_client": "Continue with client care",
			"proceed_client": "Proceed with client care",
			"proceed_home": "Proceed to the home",
			"proceed_vehicle": "Proceed to the vehicle"
		},
		"riskInstructions": {
			"add_actions": "Add actions required",
			"animals": "Be alert to pet/animal behaviours that may affect staff safety and delivery of care.",
			"apply_vat": "Apply actions listed in Section B and C of the Violence Assessment Tool (VAT)",
			"call_supervisor": "Call supervisor",
			"call_supervisor_emergency": "Call supervisor in case of emergency",
			"call_supervisor_slow": "Slow down and call supervisor",
			"call_911": "Have phone ready to call 911 if necessary",
			"contact_supervisor": "Contact supervisor",
			"find_phone": "Find nearest phone and contact supervisor",
			"illegal_activities": "Do not enter the home or if inside immediately leave dwelling if illegal activities are occurring. Contact Supervisor.",
			"personal_space": "Maintain your personal space. Leave the home immediately and contact supervisor if there is imminent threat of danger."
		}
	},
	"pdfLinks": [
		{
			"text": "C4. Parking Your Vehicle",
			"fileName": "Community_Care_C4.pdf"
		},
		{
			"text": "C5. Returning to Your Vehicle",
			"fileName": "Community_Care_C5.pdf"
		},
		{
			"text": "E1. Point-of-care Staff Work Practice Assessment",
			"fileName": "Community_Care_E1.pdf"
		}
	],
	"ui": {
		"isRiskWarningDialogShown": false,
		"isCompletionDialogShown": false,
		"isAppendixDialogShown": false
	},
	"subsections": [
		{
			"key": "environment",
			"index": 1,
			"subTitle": "Environmental Conditions",
			"comment": "",
			"appendixSections": [
				"b1",
				"b3",
				"c2",
				"c4",
				"c5"
			],
			"checkedAppendixTips": {
				"b1": [
					[]
				],
				"b3": [
					[]
				],
				"c2": [
					[]
				],
				"c4": [
					[]
				],
				"c5": [
					[]
				]
			},
			"suggestedTips": [],
			"risks": [
				{
					"question": "Has the closest and safest parking lot been located?",
					"isRisk": null,
					"whichIsRisk": "n",
					"riskText": "call_supervisor_emergency",
					"noRiskText": "proceed_home",
					"suggestedTips": [
						{
							"text": "Make sure the vehicle windows are closed and all vehicle doors are locked.",
							"references": [
								"C4"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Is the entrance visible from the road?",
					"isRisk": null,
					"whichIsRisk": "n",
					"riskText": "call_supervisor_emergency",
					"noRiskText": "proceed_home",
					"suggestedTips": [
						{
							"text": "Assess the area prior to visit for potential perpetrator hiding spots (e.g. behind bushes or hedges)?",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Turn on high beams if necessary.",
							"references": [
								"B1",
								"C4",
								"C5"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Is neighbourhood well lit?",
					"isRisk": null,
					"whichIsRisk": "n",
					"riskText": "call_911",
					"noRiskText": "proceed_home",
					"suggestedTips": [
						{
							"text": "Travel in daylight hours whenever possible.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Turn on high beams if necessary.",
							"references": [
								"C2",
								"C4"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Is the path from the parking spot to the front door well lit?",
					"isRisk": null,
					"whichIsRisk": "n",
					"riskText": "call_911",
					"noRiskText": "proceed_home",
					"suggestedTips": [
						{
							"text": "Request client/family install adequate exterior lighting and/or repairs.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Ask that entry area light be on prior to visit.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Use a flashlight if needed.",
							"references": [
								"C2",
								"C4"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Have driveways, paths and stairs been cleared to allow a worker to exit quickly if needed?",
					"isRisk": null,
					"whichIsRisk": "n",
					"riskText": "call_supervisor",
					"noRiskText": "proceed_home",
					"suggestedTips": [
						{
							"text": "Ask client/family to clear driveways, paths and stairs.",
							"references": [
								"B1"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Are there any uneven surfaces that might impede a quick exit?",
					"isRisk": null,
					"whichIsRisk": "y",
					"riskText": "call_supervisor_slow",
					"noRiskText": "proceed_home",
					"suggestedTips": [
						{
							"text": "Ask client to repair uneven surfaces.",
							"references": [
								"B1"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Is there a long approach to the road?",
					"isRisk": null,
					"whichIsRisk": "y",
					"riskText": "call_supervisor_emergency",
					"noRiskText": "proceed_home",
					"suggestedTips": [
						{
							"text": "Assess the area before visiting the home.",
							"references": [
								"B1",
								"B3"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Has the safest route for returning to the vehicle been determined?",
					"isRisk": null,
					"whichIsRisk": "n",
					"riskText": "call_supervisor_emergency",
					"noRiskText": "proceed_vehicle",
					"suggestedTips": [
						{
							"text": "Carry your keys in your hand.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Do not sling your purse or bag over your shoulder or around your neck.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Walk around vehicle and check back seat before unlocking car.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Lock doors and keep windows up until underway.",
							"references": [
								"C4"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				}
			]
		},
		{
			"key": "communication",
			"index": 2,
			"subTitle": "Communication Access",
			"comment": "",
			"appendixSections": [
				"b1"
			],
			"checkedAppendixTips": {
				"b1": [
					[]
				]
			},
			"suggestedTips": [],
			"risks": [
				{
					"question": "Is there access to a telephone, cell phone, reception or 911 communication?",
					"isRisk": null,
					"whichIsRisk": "n",
					"riskText": "find_phone",
					"noRiskText": "proceed_client",
					"suggestedTips": [
						{
							"text": "Establish a method of summoning immediate help e.g. carry a cell phone with automatic dial to 911 & /or personal safety alarm device.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Follow any ‘working alone’ precautions required.",
							"references": [
								"B1"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				}
			]
		},
		{
			"key": "animals",
			"index": 3,
			"subTitle": "Pet/Animals",
			"comment": "",
			"appendixSections": [],
			"checkedAppendixTips": {},
			"suggestedTips": [],
			"risks": [
				{
					"question": "Are there any animals in the home?",
					"isRisk": null,
					"whichIsRisk": "y",
					"riskText": "animals",
					"noRiskText": "proceed_client",
					"suggestedTips": [
						{
							"text": "Ask client/family to secure pets prior to visit as necessary.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						}
					]
				}
			]
		},
		{
			"key": "weapons",
			"index": 4,
			"subTitle": "Firearms/Weapons",
			"comment": "",
			"appendixSections": [
				"d2"
			],
			"checkedAppendixTips": {
				"d2": [
					[]
				]
			},
			"suggestedTips": [],
			"risks": [
				{
					"question": "Are there unsecured firearms/weapons in the home?",
					"isRisk": null,
					"whichIsRisk": "y",
					"isElevated": true,
					"elevatedKey": "weapons",
					"elevatedContent": "Contact supervisor and if necessary consider consulting police - do not enter or leave dwelling.",
					"elevatedDescription": "For a ‘Yes’ answer: ‘Are there firearms/weapons in the home?’",
					"noRiskText": "proceed_client",
					"riskText": "add_actions",
					"suggestedTips": [
						{
							"text": "Ensure firearms are stored in a locked cupboard and ammunition stored separately.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Inform client/family that service will be withheld until firearms are stored, unloaded and in locked cupboard.",
							"references": [
								"D2"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				}
			]
		},
		{
			"key": "cognitive",
			"index": 5,
			"subTitle": "Cognitive Ability",
			"comment": "",
			"appendixSections": [
				"a1"
			],
			"checkedAppendixTips": {
				"a1": [
					[],
					[]
				]
			},
			"suggestedTips": [],
			"risks": [
				{
					"question": "Is the client able to direct their own care?",
					"isRisk": null,
					"whichIsRisk": "n",
					"riskText": "contact_supervisor",
					"noRiskText": "proceed_client",
					"suggestedTips": [
						{
							"text": "Involve family and make aware of community resources.",
							"references": [
								"A1",
								"E2"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Is the client refusing to accept care?",
					"isRisk": null,
					"whichIsRisk": "y",
					"riskText": "contact_supervisor",
					"noRiskText": "proceed_client",
					"suggestedTips": [
						{
							"text": "Consider inter-professional referral.",
							"references": [
								"A1",
								"E1"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				}
			]
		},
		{
			"key": "behaviours",
			"index": 6,
			"subTitle": "Challenging Behaviours",
			"comment": "",
			"appendixSections": [
				"a1",
				"a2",
				"a3",
				"d1",
				"e2"
			],
			"checkedAppendixTips": {
				"a1": [
					[],
					[]
				],
				"a2": [
					[]
				],
				"a3": [
					[]
				],
				"d1": [
					[]
				],
				"e2": [
					[]
				]
			},
			"suggestedTips": [],
			"risks": [
				{
					"question": "Has a behavioral assessment such as the Violence Assessment Tool (VAT) been conducted and documented to determine the client’s risk for violent, aggressive, or responsive behaviour?",
					"isRisk": null,
					"whichIsRisk": "n",
					"riskText": "apply_vat",
					"noRiskText": "",
					"suggestedTips": []
				},
				{
					"question": "Is the client and/or family member(s) exercising or threatening to exercise physical force?",
					"isRisk": null,
					"whichIsRisk": "y",
					"isElevated": true,
					"elevatedKey": "physical_force",
					"elevatedDescription": "For a ‘Yes’ answer: ‘Is the client and/or family member(s) exercising or threatening to exercise physical force?’",
					"elevatedContent": "Contact supervisor and if necessary consider consulting police- do not enter the home or if inside immediately leave dwelling.",
					"riskText": "add_actions",
					"noRiskText": "continue_client",
					"suggestedTips": [
						{
							"text": "Update Violence Assessment Tool (VAT) when safe to do so and communicate risk to all caregivers (See PSHSA’s ICRA and Flagging Toolkit).",
							"references": [
								"A1",
								"A2"
							],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Alert supervisor of potential or an identified problem.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Is of the client exhibiting responsive behaviors to communicate unmet needs such as anxiety, pain, invasion of personal space, change in routine and noise while delivering care?",
					"isRisk": null,
					"whichIsRisk": "y",
					"riskText": "personal_space",
					"noRiskText": "continue_client",
					"suggestedTips": [
						{
							"text": "Update Violence Assessment Tool (VAT) when safe to do so.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Alert services of potential/identified problems.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Limit number of care providers going into the home – consistency of caregivers is important.",
							"references": [
								"E1",
								"E2"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Is the client and/or family member(s) showing signs of illegal drug use or drinking alcohol upon arrival??",
					"isRisk": null,
					"whichIsRisk": "y",
					"riskText": "illegal_activities",
					"noRiskText": "continue_client",
					"suggestedTips": [
						{
							"text": "Advise client/family that services may be withdrawn if identified risks occur during provision of care.",
							"references": [
								"A2"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/store/initialState/workerHomeState.json
// module id = 975
// module chunks = 0